// src/components/Services.js
import React from "react";

const services = [
  {
    title: "Business Website Development",
    text: "Professional, mobile-responsive business websites designed to build trust, showcase services, and convert visitors into genuine enquiries.",
  },
  {
    title: "E-commerce Website Development",
    text: "Secure, scalable online stores with smooth checkout, payment integration, and product management built to increase online sales.",
  },
  {
    title: "High-Converting Landing Pages",
    text: "Conversion-focused landing pages optimized for Meta and Google Ads to turn traffic into high-quality leads and real business opportunities.",
  },
];

const Services = () => {

  const scrollToForm = () => {
    const form = document.getElementById("lead-form");
    if (form) {
      form.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <section className="section" aria-labelledby="services-heading">
      <div className="section-inner">
        
        <div className="section-header">
          <h2 id="services-heading">Services built for growth</h2>
          <p>
            From first impression to final conversion, HFA Digital Creations provides end-to-end
            digital marketing and development services for startups and SMEs.
          </p>
        </div>

        <div className="grid-4 services-grid grid">
          {services.map((s) => (
            <article
              key={s.title}
              className="service-card glass-card reveal-on-scroll hover-lift"
            >
              <div className="service-icon glow-icon" aria-hidden="true">
                ▢
              </div>

              <h3>{s.title}</h3>
              <p>{s.text}</p>

              {/* CTA scroll button */}
              <span
                className="service-cta"
                onClick={scrollToForm}
                style={{ cursor: "pointer" }}
              >
                Learn more in your free call →
              </span>

            </article>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Services;